const initialState = {
};

const inventory = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default inventory;
